import * as React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { Container, Row } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import IconLandingRightArrow from '../../assets/icons/IconLandingRightArrow';
import newtheme from '../../newtheme';
import IconEllipseBottomLeft from '../../assets/icons/IconEllipseBottomLeft';
import IconEllipseTopRight from '../../assets/icons/IconEllipseTopRight';
import IconEllipseTopLeft from '../../assets/icons/IconEllipseTopLeft';
import IconEllipseBottomRight from '../../assets/icons/IconEllipseBottomRight';
import { MpTrackingButtons } from '../../config/buttons';
import IUser from '../../types/models/IUser';
import { openModal } from '../../actions/modal';
import { mpTrackButtonClick } from '../../tracking/mixpanel';
import config from '../../config';
import ModalTypes from '../../types/ModalTypes';
import { IState } from '../../reducers';
import ISubscriptionProduct from '../../domaindriven/subscribe/types/ISubscriptionProduct';
import { getSelectedSubscriptionProduct } from '../../domaindriven/subscribe/state/selectors';
import { ILandingPageSignupBlock2 } from '../../domaindriven/landing/types/ILandingPageSignupBlock2';

interface IPropsFromState {
    user?: IUser;
    subscriptionProduct?: ISubscriptionProduct;
}

interface IPropsFromDispatch {
    openModal: typeof openModal;
}

interface IProps {
    sectionData?: ILandingPageSignupBlock2;
}

class FinalCreateAccount extends React.Component<IPropsFromState & IPropsFromDispatch & RouteComponentProps & IProps> {
    public onButtonClicked = () => {
        const { subscriptionProduct } = this.props;

        if (subscriptionProduct && subscriptionProduct.metadata.homePage.redirectToPage) {
            if (this.props.user || !subscriptionProduct.metadata.homePage.showSignup) {
                this.props.history.push(subscriptionProduct.metadata.homePage.redirectToPage);
                return;
            }

            this.showSignup();
            return;
        }

        if (this.props.user) {
            this.props.history.push(config.routes.homeWebPlayer);
            return;
        }

        this.showSignup();
    };

    public showSignup = () => {
        mpTrackButtonClick(MpTrackingButtons.SHOW_SIGNUP_BOTTOM);

        this.props.openModal(ModalTypes.SignUpNew);
    };

    public render() {
        const { subscriptionProduct, sectionData } = this.props;

        return (
            <div className={css(styles.main)}>
                <IconEllipseBottomLeft className={css(styles.ellipseBottomLeft)} />
                <IconEllipseTopRight className={css(styles.ellipseTopRight)} />
                <IconEllipseTopLeft className={css(styles.ellipseTopLeft)} />
                <IconEllipseBottomRight className={css(styles.ellipseBottomRight)} />

                <Container className={css(styles.container)}>
                    <Row className={css(styles.center)}>
                        <h3 className={css(styles.heading)}>
                            {sectionData?.title || (
                                <>
                                    Empower yourself.
                                    <br />
                                    Listen to the world&apos;s best&nbsp;
                                    <br className={css(styles.breakpoint)} />
                                    audio-journalism.
                                </>
                            )}
                        </h3>
                        <button type="button" className={css(styles.button)} onClick={this.onButtonClicked}>
                            {subscriptionProduct &&
                            subscriptionProduct.metadata.homePage &&
                            subscriptionProduct.metadata.homePage.buttonText
                                ? subscriptionProduct.metadata.homePage.buttonText
                                : 'Try Noa today'}{' '}
                            <IconLandingRightArrow className={css(styles.arrow)} />
                        </button>
                    </Row>
                </Container>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    main: {
        [newtheme.cssBreakpoints.medium]: {
            height: 400,
        },
        [newtheme.cssBreakpoints.small]: {
            height: 300,
        },
        position: 'relative',
        backgroundColor: 'white',
        color: 'black',
        height: 550,
        overflow: 'hidden',
    },
    container: {
        height: '100%',
    },
    center: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    heading: {
        [newtheme.cssBreakpoints.large]: {
            fontSize: 42,
        },
        [newtheme.cssBreakpoints.medium]: {
            fontSize: 35,
            marginBottom: 35,
        },
        [newtheme.cssBreakpoints.small]: {
            fontSize: 27,
        },
        [newtheme.cssBreakpoints.tiny]: {
            fontSize: 24,
        },
        fontWeight: 500,
        fontSize: 48,
        textAlign: 'center',
        margin: 0,
        marginBottom: 45,
    },
    breakpoint: {
        '@media (min-width: 1500px)': {
            display: 'none',
        },
    },
    button: {
        [newtheme.cssBreakpoints.medium]: {
            padding: '10px 20px',
            fontSize: 16,
            borderRadius: 10,
        },
        [newtheme.cssBreakpoints.small]: {
            padding: '10px 20px',
            fontSize: 14,
            borderRadius: 10,
        },
        ':hover': {
            backgroundColor: newtheme.colors.lightNavy,
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: newtheme.colors.primaryBlue,
        color: 'white',
        border: 'none',
        borderRadius: 15,
        fontSize: 18,
        fontWeight: 500,
        padding: '20px 40px',
    },
    arrow: {
        color: 'white',
        height: 31,
        width: 33,
        stroke: 'white',
        marginLeft: 10,
    },
    ellipseTopLeft: {
        [newtheme.cssBreakpoints.large]: {
            left: 0,
            width: 167,
            height: 240,
        },
        [newtheme.cssBreakpoints.medium]: {
            left: -50,
            width: 167,
            height: 240,
        },
        [newtheme.cssBreakpoints.small]: {
            width: 140,
            height: 200,
        },
        [newtheme.cssBreakpoints.tiny]: {
            width: 104,
            height: 150,
            transform: 'rotate(30deg)',
            top: -60,
            left: 0,
        },
        position: 'absolute',
        left: 0,
        top: 0,
        width: 233,
        height: 287,
    },
    ellipseTopRight: {
        [newtheme.cssBreakpoints.small]: {
            right: 10,
            top: 20,
        },
        [newtheme.cssBreakpoints.tiny]: {
            top: 10,
            width: 70,
            height: 70,
        },
        [newtheme.cssBreakpoints.minuscule]: {
            width: 50,
            height: 50,
        },
        position: 'absolute',
        right: '10%',
        top: 50,
        width: 100,
        height: 100,
    },
    ellipseBottomRight: {
        [newtheme.cssBreakpoints.large]: {
            width: 135,
            height: 250,
        },
        [newtheme.cssBreakpoints.medium]: {
            right: -50,
        },
        [newtheme.cssBreakpoints.small]: {
            display: 'none',
        },
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: 175,
        height: 324,
    },
    ellipseBottomLeft: {
        [newtheme.cssBreakpoints.medium]: {
            display: 'none',
        },
        position: 'absolute',
        left: '15%',
        bottom: 25,
        width: 100,
        height: 100,
    },
});

function mapStateToProps(state: IState): IPropsFromState {
    return {
        user: state.user.user,
        subscriptionProduct: getSelectedSubscriptionProduct(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch): IPropsFromDispatch {
    return bindActionCreators({ openModal }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FinalCreateAccount));
